import React from 'react'
import { dateIsoToIt, numberNotation } from '../../../utils/safe'
import useTrans from '../../../hooks/useTrans'

const ProssimoArrivo = ({ prossimo_arrivo }) => {
  const t = useTrans()
  const dateIt = dateIsoToIt(prossimo_arrivo.data)
  let value = ''
  if (!dateIt && prossimo_arrivo?.disponibilita > 0) {
    value = <>Partenza da confermare -</>
  } else {
    value = dateIt ? <>{dateIt} - </> : <></>
  }

  return (
    <span
      className={
        'prossimo-arrivo' + (prossimo_arrivo.prenotabile ? ' prossimo-arrivo--prenotabile' : '')
      }
    >
      {value}
      {prossimo_arrivo?.disponibilita_reale_maggiore && t("Più di")}{' '}
      {numberNotation(prossimo_arrivo?.disponibilita)}
    </span>
  )
}

export default ProssimoArrivo
